// app/translate/translate.service.ts

import { Injectable, Inject } from '@angular/core';
import { TRANSLATIONS } from './translations'; // import our opaque token

@Injectable({
    providedIn: 'root'
})

export class TranslateService {
    private _currentLang: string;
    private PLACEHOLDER = '%'; //  placeholder

    public get currentLang() {
        return this._currentLang;
    }

    // inject our translations
    constructor(@Inject(TRANSLATIONS) private _translations: any) {
    }

    public use(lang: string): void {
        // set current language
        this._currentLang = lang;
    }

    public translate(key: string): string {
        // private perform translation
        const translation = key;

        if (this._translations[this.currentLang] && this._translations[this.currentLang][key]) {
            return this._translations[this.currentLang][key];
        } else if (this._translations['en'] && this._translations['en'][key]) {
            return this._translations['en'][key];
        } else {
            return translation;
        }
    }

    public instant(key: string, words?: string | string[]) { // add optional parameter
        const translation: string = this.translate(key);

        if (!words) { return translation; }
        return this.replace(translation, words); // call replace function
    }
    public isEnglishSelected() {
        return this._currentLang !== 'en' ? true : false;
    }

    public replace(word: string = '', words: string | string[] = '') {
        let translation: string = word;

        const values: string[] = [].concat(words);
        values.forEach((e, i) => {
            translation = translation.replace(this.PLACEHOLDER.concat(<any>i), e);
        });

        return translation;
    }
}
